import { Utility } from "./utility";
var QuestionSet = /** @class */ (function () {
    function QuestionSet() {
        this.id = null;
        this.title = "";
        this.display_order = 0;
        this.questions = [];
        this.labels = [];
        this.answer_start_value = 1;
        // options are LikertGrid, SingleSelectDropDown
        this.display_type = "MultipleChoiceGrid";
        this.display_conditions = [];
    }
    QuestionSet.prototype.getQuestionById = function (id) {
        var q = this.questions.find(function (q) { return q.id == id; });
        return q;
    };
    Object.defineProperty(QuestionSet.prototype, "display_conditions", {
        get: function () {
            return this._display_conditions;
        },
        set: function (v) {
            this._display_conditions = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionSet.prototype, "display_type", {
        get: function () {
            return this._display_type;
        },
        set: function (v) {
            this._display_type = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionSet.prototype, "id", {
        get: function () {
            return this._id;
        },
        set: function (v) {
            this._id = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionSet.prototype, "display_order", {
        get: function () {
            return this._display_order;
        },
        set: function (v) {
            this._display_order = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionSet.prototype, "answer_start_value", {
        get: function () {
            return this._answer_start_value;
        },
        set: function (v) {
            this._answer_start_value = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionSet.prototype, "title", {
        get: function () {
            return this._title;
        },
        set: function (v) {
            this._title = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionSet.prototype, "questions", {
        get: function () {
            return this._questions;
        },
        set: function (v) {
            this._questions = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionSet.prototype, "labels", {
        get: function () {
            return this._labels;
        },
        set: function (v) {
            this._labels = v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuestionSet.prototype, "instructions", {
        get: function () {
            return this._instructions;
        },
        set: function (v) {
            this._instructions = v;
        },
        enumerable: true,
        configurable: true
    });
    QuestionSet.prototype.addQuestion = function (question) {
        this.questions.push(question);
    };
    QuestionSet.prototype.removeQuestion = function (question) {
        var index = this.questions.indexOf(question);
        if (index >= 0) {
            this.questions.splice(index, 1);
        }
    };
    QuestionSet.prototype.addLabel = function (label) {
        this.labels.push(label);
    };
    QuestionSet.prototype.removeLabel = function (label) {
        var index = this.labels.indexOf(label);
        if (index >= 0) {
            this.labels.splice(index, 1);
        }
    };
    QuestionSet.prototype.shiftLabelUp = function (label) {
        Utility.shiftCollectionUp(this.labels, label);
    };
    QuestionSet.prototype.shiftLabelDown = function (label) {
        Utility.shiftCollectionDown(this.labels, label);
    };
    QuestionSet.prototype.shiftQuestionUp = function (question) {
        Utility.shiftCollectionUp(this.questions, question);
    };
    QuestionSet.prototype.shiftQuestionDown = function (question) {
        Utility.shiftCollectionDown(this.questions, question);
    };
    QuestionSet.prototype.removeScale = function (scale) {
        // get all of the scales and set them to be null
        // for those questions.
        this.questions.filter(function (q) { return q.assessment_scale.id == scale.id; })
            .forEach(function (q) { return q.assessment_scale = null; });
    };
    QuestionSet.prototype.getDisplayConditions = function () {
        return this._display_conditions;
    };
    QuestionSet.prototype.shouldDisplay = function (question_sets) {
        // cycle through any conditions based upon the question_sets and say whether the current question_set 
        // should display.
        return true;
    };
    return QuestionSet;
}());
export { QuestionSet };



// WEBPACK FOOTER //
// ./src/app/shared/models/question-set.ts.pre-build-optimizer.js